module.exports = __webpack_public_path__ + "1856f329f77fac205156ca8088890d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-32.svg
// module id = 572
// module chunks = 0